import React from 'react';
import LandingPage from './features/LandingPage';
import './App.scss';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
